// extracted by mini-css-extract-plugin
export default {"portal":"ffva_Mcd9E33nFS_GVf2","container":"NGcycd6kGw7Aylj4r45V","content":"OR2VoH3TGqipIAV36Tcw","results":"Z8oCfJQq64RNtsjcDNMZ"};